import React, { Component } from 'react';
import Utils from 'common/utils'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Constants from 'common/constants'
import CommonComponents from './commonComponents'
import Theme from 'common/theme'
import NativeAgent from 'common/nativeAgent'
import Analytics from 'analytics';

export default class ErrorView extends Component {
    componentDidMount() {
        try {
            // Have to remove all the other themes before adding this
            document.body.classList.remove(...Theme.getAllThemesBodyClasses())
            document.body.classList.add(Theme.getThemeBodyClass());
        } catch (e) {
            console.log("Error applying theme for body")
        }

        Utils.updateBodyBackgroundImage(null)

        // Add refresh handler
        CommonComponents.AddWindowRefreshHandler(this.weatherRefreshHandler.bind(this))

        // Call the native agent
        NativeAgent.addBlackListBounds("")

        // Analytics event
        Analytics.trackPageView(Constants.ANALYTICS.PAGE_VIEW.ERROR_PAGE)
        Analytics.sendEvent(
            Constants.ANALYTICS.EVENTS.CATEGORY.COMP_LOAD,
            Constants.ANALYTICS.EVENTS.ACTION.COMP_ERROR,
            null,
            null,
            true,
        )
        Analytics.sendEvent(
            Constants.ANALYTICS.EVENTS.CATEGORY.COMP_LOAD,
            Constants.ANALYTICS.EVENTS.ACTION.COMP_WENT_WRONG,
            null,
            null,
            true,
        )
    }

    weatherRefreshHandler() {
        CommonComponents.DefaultRefreshHandler()
    }

    handleTryAgainEvent(e) {
        e.preventDefault()
        window.location.reload(true)
    }

    handleLocationPicker(e) {
        e.preventDefault();
        this.setState({
            locationPickerSelected: true
        })
    }

    render() {
        return (
            <ReactCSSTransitionGroup
                transitionName="fade-in"
                transitionEnter={false}
                transitionLeave={false}
                transitionAppear={true}
                transitionAppearTimeout={Constants.FADE_IN_TRANSITION_TIMEOUT}
            >
                <div className={Theme.getThemeBaseClass()}>
                    <div className="err-container">
                        <div className="err-top-bar"></div>

                        <div className="err-msg-container">
                            <div className="text-align-center">
                                <img src="/image/error-icon.png" width="300" alt="" />
                            </div>
                            <div className="err-msg-text text-align-center">
                                <strong>
                                    Something Went Wrong!
                                </strong>
                            </div>
                        </div>
                        <div className="btn-bottom-container">
                            <button className="btn-bottom" onClick={this.handleTryAgainEvent.bind(this)}>Try Again</button>
                        </div>
                        {CommonComponents.getBottomBarComponents()}
                    </div>
                </div>
            </ReactCSSTransitionGroup>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/errorView.js